import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["fields"];
  static values = { selectedType: String };

  connect() {
    this.toggle = this.toggle.bind(this);
    this.select = this.element.querySelector("easy8-ds-select");
    this.select?.addEventListener("update:modelValue", this.toggle);

    this.selectedType = this.currentSelectedType();
    this.applyVisibility(this.selectedType);

    // DS fields (radios, text/password inputs) mount their real native elements asynchronously,
    // so the ones present at connect() time may not be all of them yet. Re-apply once they land.
    this.observer = new MutationObserver(() => this.applyVisibility(this.selectedType));
    this.observer.observe(this.element, { childList: true, subtree: true });
  }

  disconnect() {
    this.observer?.disconnect();
    this.select?.removeEventListener("update:modelValue", this.toggle);
  }

  toggle(event) {
    this.selectedType = event.detail?.[0]?.value ?? this.currentSelectedType();
    this.applyVisibility(this.selectedType);
  }

  currentSelectedType() {
    const hiddenInput = this.element.querySelector('easy8-ds-select input[name$="[credential_type]"]');
    return hiddenInput?.value || this.selectedTypeValue;
  }

  applyVisibility(selectedType) {
    this.fieldsTargets.forEach(target => {
      const isSelected = target.dataset.type === selectedType;

      target.hidden = !isSelected;
      target.querySelectorAll("input, select, textarea").forEach(field => {
        field.disabled = !isSelected;
      });
    });
  }
}
